import { HStack, Icon, Link, StackProps, useColorModeValue, useMediaQuery } from '@chakra-ui/react'
import React from 'react'
import { FaArrowRight } from 'react-icons/fa'
import { useHistory } from 'react-router'

type ArrowButtonProps = {
  buttonTitle: string
  to?: string
} & StackProps

const ArrowButton: React.FC<ArrowButtonProps> = ({ buttonTitle, to, ...rest }) => {
  const history = useHistory()
  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
  return (
    <HStack
      my="3"
      spacing="3"
      justifyContent="flex-start"
      onClick={() => history.push(to || '/')}
      {...rest}
    >
      <Link color={useColorModeValue('red.500', 'red.200')} fontWeight="bold" fontSize="sm">
        {buttonTitle}
      </Link>
      {!isTabletOrMobile && (
        <Icon color={useColorModeValue('red.500', 'red.200')} as={FaArrowRight} />
      )}
    </HStack>
  )
}

export default ArrowButton
